import { WSIcons } from "../../commonFunctions/iIcons";
import { canAccessPath, isStaffAccount } from "../../commonFunctions/staffAccess";

// Staff only get the items for modules they were given; a group with nothing left is dropped
const filterForStaff = (items: any[]): any[] =>
  items
    .map((item) => (item.children ? { ...item, children: filterForStaff(item.children) } : item))
    .filter((item) => (item.children ? item.children.length > 0 : !item.path || canAccessPath(item.path)));

export const getMenu: any = (userType: string) => {
  const menu = buildMenu(userType);
  return isStaffAccount() ? { ...menu, staticMenu: filterForStaff(menu.staticMenu) } : menu;
};

const buildMenu: any = (userType: string) => {
  return {
    staticMenu:
      userType === "pharmacy"
        ? [
          {
            id: 1,
            label: "OverView",
            icon: WSIcons.OverViewIcon,
            path: "/dashboard",
          },
          {
            id: 28,
            label: "Pharmacy Order ",
            path: "/pharmacy-orders/list",
            icon: WSIcons.OverViewIcon,
          },
          {
            id: 62,
            label: "Order History",
            icon: WSIcons.OrdersIcon,
            path: "/pharmacy-orders/history",
          },
          {
            id: 63,
            label: "Notifications",
            icon: WSIcons.OverViewIcon,
            path: "/pharmacy-notifications",
          },
          {
            id: 6,
            label: "Revenue & Payment",
            icon: WSIcons.OrdersIcon,
           
            path: "/payment/list",
            

          },

          {
            id: 2,
            label: "My Products",
            icon: WSIcons.ProductIcon,
            children: [
              {
                id: 21,
                label: "Product",
                path: "/vendor-product/list",
              },
              // {
              //   id: 28,
              //   label: "Product View",
              //   path: "/vendor-product-view",
              // },
            ],
          },
          {
            id: 70,
            label: "Settings",
            icon: WSIcons.SettingsIcon,
            children: [
              {
                id: 71,
                label: "General Settings",
                path: "/settings/general",
              },
              {
                id: 73,
                label: "Staff & Permissions",
                path: "/settings/staff",
              },
            ],
          },
        ]
        :
        [
          // {
          //   id: 3,
          //   label: "OverView",
          //   icon: WSIcons.OverViewIcon,
          //   path: "/dashboard",
          // },
          {
            id: 36,
            label: "Lab Overview",
            path: "/lab-overview",
            icon: WSIcons.OverViewIcon,
          },
          
          
         

          {
            id: 5,
            label: "Today Orders",
            icon: WSIcons.OrdersIcon,
            path: "/lab-orders/list"

            // children: [
            //   {
            //     id: 22,
            //     label: "Lab Orders ",
            //     path: "/lab-orders/list",
            //   },


            // ],
          },
          {
            id: 60,
            label: "Order History",
            icon: WSIcons.OrdersIcon,
            path: "/lab-orders/history",
          },
          {
            id: 61,
            label: "Lab Tests",
            path: "/lab-tests/list",
            icon: WSIcons.OverViewIcon,
          },
          {
            id: 62,
            label: "Lab Packages",
            path: "/lab-packages/list",
            icon: WSIcons.OverViewIcon,
          },
          {
            id: 58,
            label: "Schedules ",
            path: "/lab-schedule",
            icon: WSIcons.OverViewIcon,
          },
           {
              id: 6,
              label: " Revenue & Payment",
              icon: WSIcons.OrdersIcon,
              path: "/revenue-payments",

              // children: [
              //   // {
              //   //   id: 25,
              //   //   label: "Revenue & Payment Details ",
              //   //   path: "/revenue-details",
              //   // },
              //   {
              //     id: 26,
              //     label: "Revenue & Payment ",
              //     path: "/revenue-payments",
              //   },
                
              // ],
              
            },
           
             {
            id: 37,
            label: "Lab Technician Management",
            path: "/lab-technician-manage/list",
            icon: WSIcons.OverViewIcon,
          },


          {
            id: 21,
            label: "Lab Report",
            path: "/lab-report/list",
            icon: WSIcons.OverViewIcon,
          },
          {
            id: 55,
            label: "Lab Category",
            path: "/lab-category/list",
            icon: WSIcons.OverViewIcon,
          },
          
         
        
            // {
            //   id: 7,
            //   label: "Lab",
            //   icon: WSIcons.AllInclusiveOutlinedIcon,
            //   children: [
            //     {
            //       id: 21,
            //       label: "Lab Test & Packages ",
            //       path: "/labtestpackage/list",
            //     },
            //      {
            //       id: 21,
            //       label: "Lab Report",
            //       path: "/lab-report/list",
            //     },
            //      {
            //       id: 29,
            //       label: "Scanning Report",
            //       path: "/lab-scanning/list",
            //     },
            //     {
            //       id: 29,
            //       label: "Scan Category",
            //       path: "/scan-test/list",
            //     },
            //     {
            //       id: 36,
            //       label: "Lab Overview",
            //       path: "/lab-overview",
            //     },
            //     {
            //       id: 37,
            //       label: "Lab Technician Management",
            //       path: "/lab-technician-manage/list",
            //     },
            //        {
            //       id: 38,
            //       label: "Lab Assign Order",
            //       path: "/lab-assign-order",
            //     },
            //        {
            //       id: 39,
            //       label: "Lab Technician Details",
            //       path: "/lab-technician-details",
            //     },
            //      {
            //       id: 40,
            //       label: "Schedule Management",
            //       path: "/lab-schedule",
            //     },
            //   ],
            // },

            {
              id: 7,
              label: "Scanning",
              icon: WSIcons.AllInclusiveOutlinedIcon,
              children: [
                
                 {
                  id: 29,
                  label: "Scanning Report",
                  path: "/lab-scanning/list",
                },
                // {
                //   id: 29,
                //   label: "Scan Category with Mapping",
                //   path: "/scan-test/list",
                // },
                {
                  id: 30,
                  label: "Scan Category",
                  path: "/scan-category/list",
                },
                {
                  id: 31,
                  label: "Scan Sub Category",
                  path: "/scan-sub-category/list",
                },

              ],
            },
            {
              id: 72,
              label: "Notifications",
              icon: WSIcons.NotificationsIcon,
              children: [
                {
                  id: 59,
                  label: "Recent Notifications",
                  path: "/lab-notifications",
                },
              ],
            },
            {
              id: 70,
              label: "Settings",
              icon: WSIcons.SettingsIcon,
              children: [
                {
                  id: 71,
                  label: "General Settings",
                  path: "/settings/general",
                },
                {
                  id: 73,
                  label: "Staff & Permissions",
                  path: "/settings/staff",
                },
              ],
            },
            // {
            //   id: 5,
            //   label: " Orders",
            //   icon: WSIcons.OrdersIcon,
            //   children: [
            //     {
            //       id: 22,
            //       label: "Lab Orders ",
            //       path: "/lab-orders/list",
            //     },
               
                
            //   ],
            // },
           
             
            // {
            //             id: 6,
            //             label: "Payments",
            //             icon: WSIcons.PaymentsIcon,
            //             children: [

        ],
  };
};
